import HintCard from './HintCard';

export default HintCard;